import React from 'react';

const BranchSelect = ({ branch, handleChange }) => {
    return (
        <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="branch">
                Branch of Service*
            </label>
            <select
                id="00NHo00000XtMmi"
                name="00NHo00000XtMmi"
                value={branch}
                onChange={handleChange}
                className="block appearance-none w-full bg-white border hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                required
                title="Branch of Service"
            >
                <option value="">--None--</option>
                <option value="Army">Army</option>
                <option value="Navy">Navy</option>
                <option value="Marine Corps">Marine Corps</option>
                <option value="Air Force">Air Force</option>
                <option value="Space Force">Space Force</option>
                <option value="Coast Guard">Coast Guard</option>
                <option value="National Guard">National Guard</option>
            </select>
        </div>
    );
};

export default BranchSelect;
